import { RESET_ADDRESSES } from '../types'
export const resetaddresses = () => {

    return (dispatch) => {
        dispatch({ type: RESET_ADDRESSES });
    }
}